export const variables = () => {
  const breakPoint = 768;
  const isMobile = window.innerWidth < breakPoint;
  const ua = navigator.userAgent;
  const isUserAgentMobile = /iPhone|iPad|iPod|Android/i.test(ua);
  return {
    breakPoint,
    isMobile,
    isUserAgentMobile
  }
} 